var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.547 3.17801H20.19V14L16 9.92801L11.809 14V3.17801H6.45297C4.37496 3.17801 2.68896 4.86401 2.68896 6.94201V25.059C2.68896 27.137 4.37496 28.823 6.45297 28.823H25.547C27.625 28.823 29.311 27.137 29.311 25.059V6.94101C29.311 4.86301 27.625 3.17801 25.547 3.17801ZM14.002 24.572H6.87696V21.384H14.002V24.572Z",
    fill: "#135BA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageIcon);
export default __webpack_public_path__ + "static/media/packageIcon.7d9068b31f49cf24740056a4e34e69c1.svg";
export { ForwardRef as ReactComponent };